import { render, staticRenderFns } from "./CommonHidden.vue?vue&type=template&id=b4681f8e&scoped=true&"
import script from "./CommonHidden.vue?vue&type=script&lang=ts&"
export * from "./CommonHidden.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4681f8e",
  null
  
)

export default component.exports